import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Label, Media, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import { getZones, deleteZone } from '../../../CommonURL';
import { getDataWithToken, postDataWithToken } from '../../../Utils/restUtils';
import Transparentspinner from '../../Common/loader/Transparentspinner';
import { Add } from '../../../Constant';
import { H3, H4, Breadcrumbs } from '../../../AbstractElements';
import SearchList from '../../../CommonElements/Search';
import SweetAlert from 'sweetalert2';
import { toast } from 'react-toastify';

const Zonelist = () => {
    const [zoneData, setZoneData] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [tempSearch, setTempSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchZoneData();
    }, [searchKeyword]);

    const fetchZoneData = async () => {
        setLoading(true);
        try {
            const url = searchKeyword ? `${getZones}?search=${searchKeyword}` : getZones;
            const response = await getDataWithToken(url);
            if (response && response.status === true) {
                const formattedData = response.data.map((item, index) => {
                    return {
                        id: item.id,
                        Si: index + 1,
                        Name: item.name,
                        Countries: item.country_ids && item.country_ids.length > 0 ? item.country_ids.join(', ') : 'None'
                    }
                });
                setZoneData(formattedData);
            }
        } catch (error) {
            console.error("Error fetching zones: ", error);
        }
        setLoading(false);
    };
    
    const handleDeleteZone = (id) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this zone!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then(async (result) => {
            if (result.value) {
                setLoading(true);
                const response = await postDataWithToken(`${deleteZone}?zone_id=${id}`, { zone_id: id });
                if (response && response.data && response.data.status === true) {
                    SweetAlert.fire(
                        'Deleted!',
                        response.data.message || 'Zone has been deleted.',
                        'success'
                    );
                    toast.success(response.data.message);
                    fetchZoneData();
                } else {
                    toast.error(response?.data?.message || 'Failed to delete zone');
                }
                setLoading(false);
            }
        });
    };

    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    <DropdownItem style={toggleStyle} onClick={() => navigate(`${process.env.PUBLIC_URL}/configuration/zone-edit?id=${row.id}`)}>Edit</DropdownItem>
                    <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px', margin: '0' }} onClick={() => handleDeleteZone(row.id)}>Delete</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    };

    const zoneColumns = [
        {
            name: <H4>Sl No</H4>,
            selector: (row) => row.Si,
            sortable: true,
            width: '90px',
            center: true
        },
        {
            name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row} />,
            width: '55px',
            center: true,
        },
        {
            name: <H4>Name</H4>,
            selector: (row) => row.Name,
            sortable: true,
            wrap: true,
        },
        {
            name: <H4>Countries</H4>,
            selector: (row) => row.Countries,
            sortable: true,
            wrap: true
        }
    ];

    const updateSearchKeyword = (keyword) => {
        setTempSearch(keyword); 
    };

    const handleFilter = () => {
        setSearchKeyword(tempSearch);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle='Zone' parent="Configuration" title="Zone list" />
            <Card>
                <CardHeader><H3>Zone List</H3></CardHeader>
                <div style={{ paddingLeft: '22px', marginRight: '22px', marginBottom: '-10px' }}>
                   <div style={{ display: 'flex', alignItems: 'center', float: 'left' }}>
                        <SearchList updateSearchKeyword={updateSearchKeyword}  onEnter={handleFilter} />
                        <button className="btn btn-primary  mb-2 ms-2  " onClick={() => handleFilter()}>Filter</button>
                    </div>
                    <div style={{ float: 'right' }}>
                        <Link to={`${process.env.PUBLIC_URL}/configuration/zone-add`} className="btn btn-primary">{Add}</Link>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={zoneColumns}
                            data={zoneData}
                            pagination
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default Zonelist;
